<template>
  <div :class="classes" class="wf-relative">
    <div
      class="wf-border-2 wf-border-white wf-rounded wf-shadow wf-cursor-pointer hover:wf-shadow-md wf-overflow-visible"
      :class="pickerContainerClasses"
      @click.prevent="showPicker = ! showPicker"
      :style="{'background-color': backgroundColor}"
    ></div>
    <div :class="pickerClasses" class="wf-absolute wf-z-50" v-show="showPicker">
      <chrome-picker v-model="color" @input="updateColor"/>
    </div>
  </div>
</template>

<script>
  import {Chrome} from 'vue-color'
  export default {
    props: {
      classes: {
        type: String,
        required: false,
        default: 'picker'
      },
      value: {
        type: [Object, String],
        required: true
      },
      pickerClasses: {
        type: [String, Array],
        required: false,
        default: () => ['wf-ml-8', 'wf-top-0', 'wf-left-0']
      },
      pickerContainerClasses: {
        type: [String, Array],
        required: false,
        default: () => ['wf-h-5','wf-w-5']
      }
    },
    components: {
      'chrome-picker': Chrome
    },
    data() {
      return {
        color: this.value,
        showPicker: false
      }
    },
    watch: {
      value(value) {
        this.color = value
      },
      showPicker(value) {
        if (value) {
          document.addEventListener('click', this.closePicker)
        }
      },
    },
    computed: {
      backgroundColor() {
        let color = this.color
        if(typeof(this.color) == 'object') {
          color = `rgba(${this.color.rgba.r},${this.color.rgba.g},${this.color.rgba.b},${this.color.rgba.a})`
        }
        return color
      }
    },
    methods: {
      closePicker(event) {
        if (! event.target.closest(`.${this.classes}`)) {
          this.showPicker = false
        }
      },
      updateColor() {
        this.$emit('input', this.color)
      },
    }
  }
</script>